<template>
  <PageBreadcrumbs :items="breadcrumbs" />
  <ContentCard>
    <template #header>
      <ContentCardSubheader>
        {{ t('Reviews.product.view.mediaTitle', { productName: product.title }) }}
      </ContentCardSubheader>
    </template>

    <TabBar gap="gap-2">
      <NavTabBarItem
        :is-selected="route.meta?.tabId === ReviewsProductSubPageRoute.Widgets"
        :to="{ name: ReviewsRouteName.ReviewsProductResourcesWidgetsView }"
        data-testid="reviews-resources-tab-widgets"
      >
        {{ t('Reviews.shared.media.widgets.tabLabel') }}
      </NavTabBarItem>
      <NavTabBarItem
        :is-selected="route.meta?.tabId === ReviewsProductSubPageRoute.Badges"
        :to="{ name: ReviewsRouteName.ReviewsProductResourcesBadgesView }"
        data-testid="reviews-resources-tab-badges"
      >
        {{ t('Reviews.product.view.media.badgesTabLabel') }}
      </NavTabBarItem>
    </TabBar>

    <RouterView :product="product" />
  </ContentCard>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

import PageBreadcrumbs from '@/components/PageBreadcrumbs.vue'
import { useReviewsProductBreadcrumbs } from '@/composables/breadcrumbs/useReviewsProductBreadcrumbs'
import type { ProductById } from '@/gql/reviews'
import { ReviewsRouteName, ReviewsProductSubPageRoute } from '@/router/types'
import ContentCard from '@/ui/ContentCard.vue'
import ContentCardSubheader from '@/ui/ContentCardSubheader.vue'
import { TabBar, NavTabBarItem } from '@/ui/Tabs'

const props = defineProps<{ product: ProductById }>()
const { t } = useI18n()
const route = useRoute()
const breadcrumbs = useReviewsProductBreadcrumbs(props.product)
</script>
